import React, { useEffect, useRef } from 'react';
import { useSnackbar } from 'notistack';

const NetworkMonitor = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const offlineSnackbarKey = useRef(null);

  const onOnline = () => {
    // Close the offline snackbar if it exists
    if (offlineSnackbarKey.current) {
      closeSnackbar(offlineSnackbarKey.current);
      offlineSnackbarKey.current = null;
    }

    enqueueSnackbar('You are back online.', {
      variant: 'success',
      autoHideDuration: 3000,
    });
  };

  const onOffline = () => {
    // Avoid stacking multiple offline snackbars
    if (!offlineSnackbarKey.current) {
      offlineSnackbarKey.current = enqueueSnackbar(
        'You are offline. Restore your internet connection to use Voiceitt.',
        { variant: 'error', persist: true },
      );
    }
  };

  useEffect(() => {
    window.addEventListener('online', onOnline);
    window.addEventListener('offline', onOffline);

    // If user starts offline
    if (!navigator.onLine) onOffline();

    return () => {
      window.removeEventListener('online', onOnline);
      window.removeEventListener('offline', onOffline);
    };
  }, []);

  return null;
};

export default NetworkMonitor;
